<template>
    <div class="main-container light-bg">

        <v-layout class="grid light-bg">
            <h3 class="display-3">Tjänster</h3>
            <p class="sub-headline">Smarta Systems specialitet är att leverera skräddarsydda lösningar som på bästa möjliga sätt tillgodoser våra kunders behov, främst inom produktionsflödesområdet.</p>
        </v-layout>

        <v-layout v-if="wpData" class="grid grid-two blue-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
            <section class="grid-item">
                <img src="../assets/imgs/macVISMA.png" class="grid-item-left-image">
            </section>
            <section class="grid-item">
                <h3 class="display-3">{{wpData[1].title.rendered}}</h3>
                <br>
                <span v-html="wpData[1].content.rendered"></span>
            </section>
        </v-layout>
        <v-layout v-else class="grid grid-two blue-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
            <section class="grid-item">
                <img src="../assets/imgs/macVISMA.png" class="grid-item-left-image">
            </section>
            <section class="grid-item" style="width:100%;">
                <v-skeleton-loader
                    class="mx-auto bluebackground"
                    type="article"
                    ></v-skeleton-loader>
            </section>
        </v-layout>

         <v-layout v-if="wpData" class="grid grid-two light-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
            <section class="grid-item">
                <h3 class="display-3">{{wpData[0].title.rendered}}</h3>
                <br>
                <span v-html="wpData[0].content.rendered"></span>                    
            </section>
            <section class="grid-item">
                <img src="../assets/imgs/macFM2.png" class="grid-item-left-image">
            </section>
        </v-layout>
         <v-layout v-else class="grid grid-two light-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
             <section class="grid-item" style="width:100%;">
                <v-skeleton-loader
                    class="mx-auto"
                    type="article"
                    ></v-skeleton-loader>
            </section>
            <section class="grid-item">
                <img src="../assets/imgs/macFM2.png" class="grid-item-left-image">
            </section>
        </v-layout>

        <v-layout row wrap class="grid blue-bg">
            <h5 class="display-3 tjanster-fragor">Har du frågor kring våra tjänster?</h5>
            <div class="read-more" style="text-align: center">
            <router-link to="/kontakt">
                <button>Kontakta oss</button>
            </router-link>
        </div>
        </v-layout>

        

        <!-- <v-layout class="grid grid-two light-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
            <section class="grid-item">
                <h3 class="display-3">SmartIntegration - Visma eEkonomi</h3>
                <br>
                <p>Med SmartIntegration för Visma Spcs kopplar du ihop din FileMakerlösning med ditt administrationsprogram från    Visma Spcs. All information som du kan bearbeta i Visma Spcs kan du nu komma åt i FileMaker.
                    Du kan med SmartIntegration automatiskt skapa fakturor, lägga in order, synkronisera ditt kundregister direkt från din FileMakerlösning. SmartIntegration möjliggör snabb direkt integration med Visma Spcs, utan att du behöver använda mellanliggande exportfiler.
                </p>
                <hr class="system-reqs-hr">
                <p><strong><i>SYSTEMKRAV</i></strong></p>      
                    <p class="system-specs">SmartIntegration är för FileMaker version 8 till och med 12. Programmet kräver Windows XP, Vista eller 7. SmartIntegration kan integreras med Visma Administration 500, 1000 och 2000, Visma Förening, Visma Compact samt Visma Lön 300 och 600. SmartIntegration kräver produkten Visma Integration från Visma.</p>
                    
            </section>
            <section class="grid-item">
                <img src="../assets/imgs/macFM2.png" class="grid-item-left-image">
            </section>
        </v-layout> -->

        <!-- <v-layout class="grid grid-two blue-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
            <section class="grid-item">
                <img src="../assets/imgs/macFM.png" class="grid-item-left-image">
            </section>
            <section class="grid-item">
                <h3 class="display-3">SmartIntegration - FortKnox</h3>
                <br>
                <p>Med SmartIntegration för Visma Spcs kopplar du ihop din FileMakerlösning med ditt administrationsprogram från    Visma Spcs. All information som du kan bearbeta i Visma Spcs kan du nu komma åt i FileMaker.
                    Du kan med SmartIntegration automatiskt skapa fakturor, lägga in order, synkronisera ditt kundregister direkt från din FileMakerlösning. SmartIntegration möjliggör snabb direkt integration med Visma Spcs, utan att du behöver använda mellanliggande exportfiler.
                </p>
                <hr class="system-reqs-hr">
                <p><strong><i>SYSTEMKRAV</i></strong></p>      
                    <p class="system-specs">SmartIntegration är för FileMaker version 8 till och med 12. Programmet kräver Windows XP, Vista eller 7. SmartIntegration kan integreras med Visma Administration 500, 1000 och 2000, Visma Förening, Visma Compact samt Visma Lön 300 och 600. SmartIntegration kräver produkten Visma Integration från Visma.</p>
            </section>
        </v-layout> -->

    </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component({
    data(){
      return {
          wpData: ""
      }
    },
    components: {},
    methods: {
        async getData(){
            await fetch(this.$store.state.URL+'pages?include=16,14')
            .then((r) => r.json())
            .then((res) => {
              this.wpData = res;
              });
            },
    },
    beforeMount(){
        this.getData();
    }
})
export default class Tjanster extends Vue {}
</script>

<style lang="scss">

</style>